import React, { useEffect } from 'react';
import Link from '@material-ui/core/Link';
import { datadogRum } from '@datadog/browser-rum';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { UI_SET_BRAND } from '../../redux/action-types/ui-types';
import { ThemeDefault } from '../../theming/themes';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {
  clearEmailAndPhoneTypesData,
  clearPaginationInfo,
} from '../../redux/actions/restaurantsActions';
import { useOktaAuth } from '@okta/okta-react';
import { auth } from '../../utils/utils';
import {
  setFrumUser,
  setRBIConnectUser,
  setUserAccess,
} from '../../redux/actions/userActions';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { getAvailableLanguages } from '../../redux/actions/appActions';

const setupDatadogRumContext = (oktaProfile: any) => {
  if (oktaProfile) {
    datadogRum.setUser({
      id: oktaProfile.sAMAccountName,
      rbiBrandCode: oktaProfile.rbiBrandCode,
      franOrganizationId: oktaProfile.FranOrganizationID,
      userType: oktaProfile.userType,
    });
  }
};

export default function BrandSelector() {
  const dispatch: any = useDispatch();
  const { brands, userInfo } = useSelector(
    (state: RootStateOrAny) => state.UserReducer,
  );
  const { selectedBrand } = useSelector(
    (state: RootStateOrAny) => state.UIReducer,
  );
  const { oktaAuth, authState } = useOktaAuth();

  const handleSetBrand = brand => {
    if (brand !== selectedBrand) {
      dispatch(clearPaginationInfo());
      dispatch(clearEmailAndPhoneTypesData());
      dispatch({
        type: UI_SET_BRAND,
        payload: {
          brand,
          theme: ThemeDefault,
        },
      });
      dispatch(getAvailableLanguages(1, brand));
    }
  };
  useEffect(() => {
    if (authState) {
      const idToken = authState?.idToken?.idToken;
      if (authState.isAuthenticated && idToken) {
        const decodedIdToken = oktaAuth.token.decode(idToken.toString());
        if (decodedIdToken?.payload?.groups) {
          if (Object.keys(userInfo).length === 0) {
            dispatch(
              setRBIConnectUser(
                decodedIdToken.payload,
                decodedIdToken.payload.groups,
              ),
            );
          }
        } else if (Object.keys(userInfo).length === 0) {
          const brand =
            selectedBrand === 'BK'
              ? 1
              : selectedBrand === 'PLK'
                ? 2
                : selectedBrand === 'TH'
                  ? 3
                  : null;
          dispatch(
            setFrumUser(
              decodedIdToken.payload.preferred_username,
              brand,
              userInfo,
            ),
          );
        }
      }
    }
  }, [brands, userInfo, authState, dispatch, selectedBrand]);

  useEffect(() => {
    const oktaProfile = authState?.idToken?.claims;
    if (oktaProfile) {
      setupDatadogRumContext(oktaProfile);
    }
  }, [authState]);

  useEffect(() => {
    if (brands.length && !selectedBrand) {
      handleSetBrand(brands[0].brandCode);
    }
  }, [brands, selectedBrand]);

  const history = useHistory();
  const { permissions } = useSelector(
    (state: RootStateOrAny) => state.UserReducer,
  );

  useEffect(() => {
    if (permissions.length) {
      dispatch(setUserAccess(auth(permissions)));
    }
  }, [permissions, dispatch]);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.target);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickSetBrand = brand => () => {
    const idToken = authState?.idToken?.idToken || '';
    const decodedIdToken = oktaAuth.token.decode(idToken.toString());
    if (Object.prototype.hasOwnProperty.call(localStorage, 'profile')) {
      const { userType } = JSON.parse(localStorage.getItem('profile') || '{}');
      if (userType === 'Franchise' && !decodedIdToken?.payload?.groups) {
        dispatch(
          setFrumUser(decodedIdToken.payload.preferred_username, brand.brandId),
        );
      }
    }
    handleSetBrand(brand.brandCode);
    setAnchorEl(null);
    history.push('/restaurants');
  };

  const { t } = useTranslation();

  return (
    <div>
      {brands.length > 1 && (
        <>
          <Link
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={handleClick}
            style={{ color: 'white', fontSize: 15, cursor: 'pointer' }}
          >
            {t('app.common.switchBrands')}
          </Link>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            {brands.map((brand, index) => (
              <MenuItem key={index} onClick={handleClickSetBrand(brand)}>
                {brand.brandName}
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    </div>
  );
}
